let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kjrVr")).then(() => parcelRequire('eqvGW'));